module.exports = __webpack_public_path__ + "static/media/icn-aluminio-05.36d2a309.svg";